import './App.css';
import React, { useEffect,useState } from 'react';
import { Link } from "react-router-dom";
import whiteLogo from './Assets/Artboard 11_1.png';
import { howItWorksData } from './Assets/howItWorks';
import { RxCheckCircled } from "react-icons/rx";
import { FaArrowCircleRight } from "react-icons/fa";
import { FaArrowCircleLeft } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa6";
import testimonial1 from './Assets/testimonial1.png';
import testimonial2 from './Assets/testimonial2.png';
import testimonial3 from './Assets/testimonial3.png';
import editor from './Assets/editor.jpg';
import director from './Assets/director.jpg';
import talent from './Assets/cameraTalent.png';
import pitch from './Assets/pitch.jpg';
import staticBG from './Assets/static.gif';
import HowItWorks from './Componets/HowItWorks';
import landing2 from './Assets/JNS07129.jpg';

const faqs = [
  {
    question: "Can I use Viddy with a teleprompter?",
    answer: "Viddy only works with the elgato prompter and does not work with a classic mirrored teleprompter. However Viddy is designed to be able to be used from a computer screen like a teleprompter without needing one. "
  },
  {
    question: "Where do I download Viddy Studio?",
    answer: "You actually don’t download Viddy Studio but access through our website [Viddystudio.com](http://app.Viddystudio.com) and you sign into your account."
  },
  {
    question: "How much time can Viddy save me?",
    answer: "With 30 minutes of footage, you can expect 1-2 hours to re-watch and filter through mess ups, retakes, and dead space. However with the Editmap, you can instantly see where to make your cuts and edit that same 30 minutes of footage in less than 5 minutes."
  },
  {
    question: "Can I collaborate with my team in Viddy Studio?",
    answer: "For now, teams collaborate by using a single shared account. Mainly one person from your team will manage your viddy account but multiple people from your team will interact with it."
  },
  {
    question: "Can I import my scripts into Viddy?",
    answer: "Yes, you can import by clicking our import button and copy and pasting your script."
  },
  {
    question: "Can I use any camera with Viddy?: Yes. As long as it can detect the bell sound from Viddy.",
    answer: "No, you still need to use your editing software to actually cut your footage. Viddy assists in the planning, shooting, and then gives you an editmap to help you edit but doesn’t actually cut the footage for you."
  },
  {
    question: "Do I have to use an external camera?",
    answer: "For now yes but we are working on a connect feature to use a webcam in the future. "
  }
];

function App() {
  const [pricingBoolean, setPricingBoolean] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [email, setEmail] = useState("");

  const pricingToggle = () => setPricingBoolean(prev => !prev);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % howItWorksData.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [activeIndex]);

    const handleNext = () => {
      setActiveIndex((prev) => (prev + 1) % howItWorksData.length);
    };

    const handlePrev = () => {
      setActiveIndex((prev) =>
        prev === 0 ? howItWorksData.length - 1 : prev - 1
      );
    };
    const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("entry.1830464977", email); // 👈 your correct entry ID

    fetch(
      "https://docs.google.com/forms/d/e/1FAIpQLSeBogBPj2oUbfaxLmEW9dKOU3gU42vvrDT8cxudSTItSVs6dg/formResponse",
      {
        method: "POST",
        mode: "no-cors",
        body: formData,
      }
    )
      .then(() => console.log("Form submitted successfully"))
      .catch((err) => console.error("Error submitting form", err));

    setEmail("");
  };

  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="App">
      {/* <div class="glow-background">
        <div class="glow-layer"></div>
      </div> */}
      <div className="Veil">
        <img className="VeilGif" alt='scratched film background gif' src={staticBG}/>
        {/* <DarkVeil/> */}
      </div>
      <div className="LandingContainer">
        <div className="Landing">
          <h1>Record Smarter, Edit Faster.</h1>
          <img src={landing2} className="landingImg" />
          <h2>Speak on camera like a pro and streamline your productions with our content creation process.</h2>

        <a className="tryBtn" href="https://app.viddystudio.com" target="_blank" rel="noopener noreferrer">
          TRY FOR FREE
        {/* <form onSubmit={handleSubmit} className="email-box">
          Request Early Access
          <div>
          <input
            className="email-input"
            type="email"
            name="entry.183046977"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="email-btn">Submit</button>
          </div>
        </form> */}
          </a>
        </div>
        <div className="second">
          <iframe className='videoContainer' src="https://www.youtube.com/embed/E25bALFu3Ek?si=3r8oJE3kWE0JZt5u" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"></iframe>
        </div>
      </div>
      <div className="howItWorks">
        <HowItWorks/>
      </div>
      <div className="About" id="About">
            <div className="aboutsubTitle">
              <b>You don't need a new camera.</b>
              <b>You need a better process.</b>
              </div>
            <div className="AboutSubText">Viddy Studio is a process designed to output more confident and valuable videos. A repeatable strategy for creating great videos on repeat.The best part is, it helps the whole crew.</div>
            <div className="AboutColumns">
              <p className="AboutCol"><b>DIRECTORS AND<br/> VIDEOGRAPHERS</b>
              <img src={director} alt="Director using Viddy" className="aboutImg"/>
              {/* <GiVideoCamera className="AboutIcon"/> */}
              Viddy pairs from your phone or computer wirelessly to any camera through a bell sound and replaces the need for a traditional teleprompter.</p>
              <p className="AboutCol"><b>ON-CAMERA TALENT</b>
              {/* <BsPersonBoundingBox className="AboutIcon"/> */}
              <img src={talent} alt="On-camera talent using Viddy" className="aboutImg"/>
              Speak on camera with confidence and deliver your best takes. Viddy walks you through your script in bitesized sections allowing you to record as many takes as you need until you get it right.</p>
              <p className="AboutCol"><b>EDITORS</b>
              {/* <FaComputer className="AboutIcon"/> */}
              <img src={editor} className="aboutImg"/>
              Edit lightning fast with the Editmap generated by Viddy. You can visually see where to make your cuts so you don't need to watch back all of the raw footage.</p>
            </div>
            
      </div>
      <div className="HowSection" id="How">
                <div className="Arrows">
                <div className="ArrowButton left" onClick={handlePrev}><FaArrowCircleLeft/></div>
                <div className="ArrowButton right" onClick={handleNext}><FaArrowCircleRight/></div>
              </div>
        <div className="HowCards">
          {howItWorksData.map((item, index) => (
            <div
              key={index}
              className={`HowCard ${index === activeIndex ? "active" : "inactive"}`}
            >
              {/* <div>{item.content}</div> */}
              <div className="HowTitle">{item.title}</div>
              <div className="HowSubTitle">{item.description}</div>
            </div>
          ))}
        </div>
        <div className="LaptopImageContainer">
          {howItWorksData.map((item, index) => (
            <img
              key={index}
              src={item.image}
              alt={item.title}
              className={`LaptopImage ${index === activeIndex ? "active" : ""}`}
            />
          ))}
        </div>
      </div>

      <div className="Testimonials">
        <div className="TestHeader">What Our Creators Say</div>
        <div className="TestColumns">
          <div className="TestColumn">
            {/* <div className="TestTitle">Content Creator</div> */}
            <div>"Viddy Studio has been such an amazing tool. From planning to shooting to editing. It allows me to focus on other creative aspects of my projects."</div>
            <div className="TestBottom">
              <div className="TestName">TRENTON TEASDALE</div>
              <img alt="Testimonial User1" src={testimonial1} className="TestImg"/>
            </div>
          </div>
          <div className="TestColumn">
            {/* <div className="TestTitle">CEO, Your Life Legacy</div> */}
            <div>"I just made ads using Viddy Studio and it made everything so seamless and easy. I'm horrible on camera and they just made it seamless and so much better."</div>
            <div className="TestBottom">
              <div className="TestName">JAXON CUMMINGS</div>
              <img alt="Testimonial User2" src={testimonial2} className="TestImg"/>
            </div>
          </div>
          <div className="TestColumn">
            {/* <div className="TestTitle">Papa Bird Studios</div> */}
            <div>"It made things easier for all parties, and we were able to get through our scripted corporate videos in a fraction of the time! Essential, especially if you’re recording people who aren’t used to being in front of the camera.”</div>
            <div className="TestBottom">
              <div className="TestName">JAKE LOVELAND</div>
              <img alt="Testimonial User3" src={testimonial3} className="TestImg"/>
            </div>
          </div>
        </div>
      </div>
      <div className="second">
          <iframe className='videoContainer' src="https://www.youtube.com/embed/bJFOu1HCmho?si=WsXXAS_sE-UvojpF" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"></iframe>
      </div>
      <div className="Pitch">
        <div className="PitchHeader">
          <h2 className="PitchTitle">Make videos that matter.</h2>
          <img src={pitch} className="PitchImg"/>
        </div>
        <div className="PitchMsg">
          <div>Step into your courage and create something worth sharing. Don't just keep up with the noise, lead the movement.</div>
          <br/>
          <div>All of the fanciest edits and tactics won't mean anything if you don't capture a great story and delivery in the first place. Viddy Studio brings the message and story to the forefront of our process. </div>
        </div>
        
      </div>
      <div className="faqSection">
        <p className="faqHeader">Frequently Asked Questions</p>
        <section className="faq">
        {faqs.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? "active" : ""}`}
          >
            <button
              className="faq-question"
              onClick={() => toggle(index)}
            >
              <span>{item.question}</span>
              <span className="icon">+</span>
            </button>

            <div
              className="faq-answer"
              style={{
                maxHeight: openIndex === index ? "200px" : "0px"
              }}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
    </section>
      </div>

      <div className="Pricing" id="Pricing"> 
        <h3>Pricing</h3>
        <div className="PricingToggle">
        Monthly
      <div
        className={`toggle-switch ${pricingBoolean ? 'on' : ''}`}
        onClick={pricingToggle}
      >
        <div className="toggle-thumb" />
      </div>
      Yearly
      </div>
        <div className="PricingCards">
          <div className="PriceCard">
            <b className="PriceTitle">
              VIDDY CREATOR
            </b>
            <b className="Price">
              Free
            </b>
            <div className="Features">
              <div><RxCheckCircled /> Unlimited Scripts</div>
              <div><RxCheckCircled /> 3 Videos Per Month</div>
              <div><RxCheckCircled /> Discord Community</div>
            </div>
            <div className="PricingBtn"><a href="https://app.viddystudio.com" target="_blank" rel="noopener noreferrer">Get Started For Free</a></div>
          </div>
                    <div className="PriceCard PriceCard2">
            <b className="PriceTitle">
              VIDDY PRO
            </b>
            <b className="Price">
              {pricingBoolean ? <>$199 / Year</> : <>$20 / Month</>}
            </b>
            <div className="Features">
              <div><RxCheckCircled /> Unlimited Scripts</div>
              <div><RxCheckCircled /> Unlimited Videos</div>
              <div><RxCheckCircled /> Premium Support</div>
            </div>
            <div className="PricingBtn"><a href="https://app.viddystudio.com" target="_blank" rel="noopener noreferrer">Get Started For Free</a></div>
          </div>
                    <div className="PriceCard">
            <b className="PriceTitle">
              VIDDY TEAMS
            </b>
            <b className="Price">
              Custom
            </b>
            <div className="Features">
              <div><RxCheckCircled /> Get in touch for your own use case</div>
              <div><RxCheckCircled /> Custom Solutions</div>
            </div>
            <div className="PricingBtn"><a href="mailto:Kensington@viddystudio.com" target="_blank" rel="noopener noreferrer">Contact Sales</a></div>
          </div>
        </div>
      </div>
      <div className="Footer">
        <div className="FooterLeft">
          <img alt="Viddy Logo" className="Logo" src={whiteLogo} />
          <div className="FooterIcons">
            {/* <a href="" target="_blank" rel="noopener noreferrer"><FaXTwitter/></a> */}
            <a href="https://www.youtube.com/@viddystudio" target="_blank" rel="noopener noreferrer"><FaYoutube/></a>
            <a href="https://www.instagram.com/viddystudio/" target="_blank" rel="noopener noreferrer"><FaInstagram/></a>
            <a href="https://www.linkedin.com/company/viddystudio" target="_blank" rel="noopener noreferrer"><FaLinkedin/></a>
            <a href="https://www.facebook.com/p/Viddy-Studio-61556643364778/" target="_blank" rel="noopener noreferrer"><FaFacebook/></a>
          </div>
        </div>
        <div className="FooterRight">
          <Link to="/terms-of-service">TERMS OF SERVICE</Link>
          <Link to="/privacy-policy">PRIVACY POLICY</Link>
        </div>
      </div>
    </div>
  );
}

export default App;
